// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 141 ? "f94af2ce" : chunkId) + "." + {"141":"cd478da370c83436","713":"652bc51388d271ca"}[chunkId] + ".js";
};